export const SETTINGS_LIST = {
  'amocrm-integration': {
    routeName: 'SettingsIntegrationAmoCrm',
    title: 'Интеграция с AmoCRM'
  }
}
